import {
    ADD_MULTIBET_SELECTION,
    REMOVE_MULTIBET_SELECTION,
    SELECT_RACING_BET_TYPE,
    TOGGLE_BETTING_TYPE_BUTTON_DISPLAYED,
    TOOGLE_BOX_BETS
} from '../constants/actionTypes';

export function selectRacingBetType(betType) {
    return {type: SELECT_RACING_BET_TYPE, betType};
}

export function toggleBettingTypeButtonsDisplayed() {
    return {type: TOGGLE_BETTING_TYPE_BUTTON_DISPLAYED};
}

export function addMultiBetSelection(racerNum, multiBetSelections) {
    if (multiBetSelections && multiBetSelections.length < 3) {
        return {type: ADD_MULTIBET_SELECTION, racerNum};
    }
    return {type: 'IGNORE'};
}

export function removeMultiBetSelection(racerNum) {
    return {type: REMOVE_MULTIBET_SELECTION, racerNum};
}

export function toogleBoxBets() {
    return {type: TOOGLE_BOX_BETS};
}



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/modules/racing/actions/raceCardActions.js